export const USER_JOURNEY_NAMES = {
  CHECKOUT: 'afterpay-checkout',
} as const

export type UserJourneyName = (typeof USER_JOURNEY_NAMES)[keyof typeof USER_JOURNEY_NAMES]

export const USER_JOURNEY_EVENTS = {
  STARTED: 'uj.journey.started',
  COMPLETED: 'uj.journey.completed',
} as const

export const USER_JOURNEY_VARIANTS = {
  PAY_IN_2: 'pay-in-2',
  PAY_IN_4: 'pay-in-4',
  PAY_MONTHLY: 'pay-monthly',
  APPLE_RETAIL: 'apple-retail',
} as const

export const USER_JOURNEY_APPLICATION_NAME = 'rocketship'
export const USER_JOURNEY_PLATFORM_NAME = 'web'

export const FEDERATION_OUTBOX_KEY = 'apt-uj-federation-outbox'

export const USER_JOURNEY_TIMEOUT_MS = 10 * 60 * 1000

export const USER_JOURNEY_TIMEOUT_LATE_FIRE_GRACE_MS = 5 * 1000

export const IDENTITY_VERIFICATION_SIGNALS = {
  REQUIRED: 'identity-verification-required',
} as const

export const CASH_AUTH_SIGNALS = {
  DECLINED: 'cash-authorization-declined',
  TIMEOUT: 'cash-authorization-timeout',
} as const
